import React, { useCallback, useEffect } from 'react';

import axios from 'axios';
import PropTypes from 'prop-types';

import { LoginForm } from '../login/login-form';

export const IDPLoginPage = ({ userRoles }) => {
  const query = new URLSearchParams(window.location.search);
  const challenge = query.get('login_challenge') || '';

  const onLoginSuccess = useCallback(() => {
    const formData = new FormData();
    formData.append('login_challenge', challenge);
    axios
      .post('/idp/login', formData, {
        headers: {
          ContentType: 'multipart/form-data',
        },
      })
      .then(({ data }) => (window.location.href = data.redirectUrl))
      .catch((error) => window.console.log('Error', error));
  }, [challenge]);

  useEffect(() => {
    if (userRoles) {
      onLoginSuccess();
    }
  }, [userRoles, onLoginSuccess]);

  if (userRoles) {
    return null;
  }

  return <LoginForm onLoginSuccess={onLoginSuccess} shouldRenderRememberMe={false} />;
};

IDPLoginPage.propTypes = {
  userRoles: PropTypes.array,
};
